import { SET_SESSION_ID } from './actionTypes';

export const setSessionId = (sessionId: string, sessionIdStateLocation: string, activeSessionStateLocation: string, isActiveSession: boolean) =>
{
    return {
        type: SET_SESSION_ID,
        payload: {
            sessionId,
            sessionIdStateLocation,
            activeSessionStateLocation,
            isActiveSession,
        },
    };
};


// WEBPACK FOOTER //
// ./modules/session-id-override-processor/actions/actions.ts